import { CloseIcon } from '@/icons';
import { Guide } from '@/lib/types';
import { NAVBAR_Z_INDEX } from '@/lib/utils';
import { Employee } from '@/widgets';
import { Modal, ModalProps } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classnames from './modal.module.css';

type Props = ModalProps & {
  guide?: Guide;
};

export default function GuideModal({ opened, onClose, guide }: Props) {
  const isMobile = useMediaQuery('(max-width: 600px)');

  return (
    <Modal.Root opened={opened} onClose={onClose} size="60rem" zIndex={NAVBAR_Z_INDEX + 2} fullScreen={isMobile}>
      <Modal.Overlay />
      <Modal.Content classNames={{ content: classnames.modal }}>
        <Modal.Header className={classnames.modal__header}>
          <Modal.Title className={classnames.title}>
            <span className={classnames.left__line}></span>
            {guide?.position}
            <span className={classnames.right__line}></span>
          </Modal.Title>
          <Modal.CloseButton icon={<CloseIcon />} className={classnames.close__btn} />
        </Modal.Header>
        <Modal.Body className={classnames.modal__body}>
          {guide ? <Employee {...guide} className={classnames.guide} /> : null}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}
